import styled, { DefaultTheme } from 'styled-components';

import { media } from '~src/styles/media-templates';

export const RightCol = styled.div`
  margin-left: 15px;
  align-self: center;
  > * {
    transition: opacity 300ms;
  }
`;

export const HeaderContainer = styled.header<{ $withBorder?: boolean }>`
  min-height: 165px;
  padding: 15px ${({ theme }) => theme.sz.pageSidePadding} 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  ${({ $withBorder, theme }) => $withBorder && `border-bottom: 1px solid ${theme.black.a1}`};
  ${media.desktop`
    padding: 15px ${({ theme }) => (theme as DefaultTheme).sz.pageSidePaddingS} 0;
  `}

  &.small-header {
    min-height: 0;
    padding-top: 5px;
    padding-bottom: 19px;
  }
`;

export const MainCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 30px;
  h1 {
    font-size: 2.33rem;
    transition: font-size 300ms;
  }
  .description {
    max-width: 825px;
    max-height: 100px;
    font-size: 1rem;
    color: ${({ theme }) => theme.baseBlue.a6};
    margin-top: 5px;
    transition: all 300ms;
  }

  &.small-header {
    padding-bottom: 0;
    h1 {
      font-size: 1.133rem;
      font-weight: bold;
    }
    .description {
      overflow: hidden;
      opacity: 0;
      max-height: 0;
      margin-top: 0;
    }
  }

  ${media.tablet`
    h1 {
      font-size: 1.2rem;
      font-weight: bold;
    }
  `}
  ${media.phone`
    .description {
      font-size: 0.8rem;
    }
  `}
`;
